import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from './config.service';
import { CreditReportFetchResponse } from '../model/cibil/credit-bureau.model';


@Injectable()
export class CreditBureauService {

    constructor(
        private readonly httpClient: HttpClient,
        private readonly configService: ConfigService
    ) {
    }

    public async getAllCreditReports(panNumber: string): Promise<PaginatedData<CreditReportFetchResponse>> {
        const params = new HttpParams().set('panNumber', panNumber);

        const baseUrl = `${this.configService.getCreditBureauServiceBaseUrl()}/credit-reports`;
        return await this.httpClient.get<PaginatedData<CreditReportFetchResponse>>(baseUrl, { params }).toPromise();
    }

    public async getCreditReportById(Id: string): Promise<CreditReportFetchResponse> {
        const baseUrl = `${this.configService.getCreditBureauServiceBaseUrl()}/credit-report/${Id}?withFile=true`;
        return await this.httpClient.get<CreditReportFetchResponse>(baseUrl).toPromise();
    }
}


export interface PaginatedData<T> {
    content: T[];
    pageable?: {
        page: number;
        size: number;
        sort: {
            orders: {
                direction: string;
                property: string;
                ignoreCase: boolean;
                nullHandling: string;
            }[]
        }
    };
    total: number;
}